// extracted by mini-css-extract-plugin
module.exports = {"carousel":"ListPresentation_carousel__wtJ8q","group":"ListPresentation_group__j8hdO","scrolling":"ListPresentation_scrolling__byDt8"};